import template from './pregled.html';
import {PregledController} from './pregled.controller.js';

const PregledComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: PregledController,
    controllerAs: 'vm'
};

export {PregledComponent};



// WEBPACK FOOTER //
// ./app/components/pregled/pregled.component.js